
import { Layout } from 'antd';
import ModuleRoutes from '../modules/routes';
import TopHeader from './components/header/TopHeader';
import NavSide from './components/sider/NavSide';
import ModuleWorkspace from './components/navigation/ModuleWorkspace';
import { useCallback, useEffect, useState } from 'react';
import ReleaseNotePopup from '../modules/whatsNew/ReleaseNotePopup';

const { Content } = Layout;
const MOBILE_BREAKPOINT = 1024;

const Layouts = () => {
  const [shellReady, setShellReady] = useState(false);
  const [isMobileViewport, setIsMobileViewport] = useState(window.innerWidth < MOBILE_BREAKPOINT);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const [navigationState, setNavigationState] = useState({
    navigation: null,
    notificationModules: [],
    loading: true,
  });

  const onNavigationChange = useCallback((nextNavigationState) => {
    setNavigationState(nextNavigationState);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobileViewport(isMobile);

      if (!isMobile) {
        setMobileNavOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const shouldLockScroll = isMobileViewport && mobileNavOpen;

    document.body.classList.toggle('app-navigation-overlay-open', shouldLockScroll);

    return () => {
      document.body.classList.remove('app-navigation-overlay-open');
    };
  }, [isMobileViewport, mobileNavOpen]);

  return (
      <Layout className={ `app-shell${shellReady ? ' app-shell--ready' : ' app-shell--booting'}` } style={ { minHeight: '100dvh', background: 'var(--klok-page-bg)' } }>
        <NavSide
          onReady={ () => setShellReady(true) }
          isMobileViewport={ isMobileViewport }
          mobileNavOpen={ mobileNavOpen }
          setMobileNavOpen={ setMobileNavOpen }
          onNavigationChange={ onNavigationChange }
        />
        <Layout className="app-shell__main" style={ { minHeight: '100dvh', background: 'transparent' } }>
          <TopHeader
            navigation={ navigationState.navigation }
            isMobileViewport={ isMobileViewport }
            mobileNavOpen={ mobileNavOpen }
            onToggleNavigation={ () => setMobileNavOpen((current) => !current) }
          />
          <Content className='maincontent'>
            <ModuleWorkspace
              navigation={ navigationState.navigation }
              notificationModules={ navigationState.notificationModules }
              loading={ navigationState.loading }
            >
              <ModuleRoutes />
            </ModuleWorkspace>
          </Content>
          <ReleaseNotePopup />
        </Layout>
      </Layout>

  );
};

export default Layouts;
